<div class="account-deletion-container">
  <div class="account-deletion-header">
    <div [innerHtml]="'home.account-deletion.keep-in-mind' | translate"></div>
  </div>

  <br />
  <slotcom-divider></slotcom-divider>
  <br />

  <div>
    <span [innerHtml]="'home.account-deletion.deletion-reminder-1' | translate"></span>
    <b
      ><span>{{ remainingDays }}</span></b
    >
    <span [innerHtml]="'home.account-deletion.deletion-reminder-2' | translate"></span>
  </div>
  <br />

  <div [innerHtml]="'home.account-deletion.sure-to-reactivate' | translate"></div>

  <br />
  <slotcom-divider></slotcom-divider>
  <br />

  <div class="account-deletion-footer">
    <br />
    <div class="button-container">
      <slotcom-button
        class="c-button--purple left-btn"
        (safeClick)="cancelDeletion()"
        audioType="functionality">
        {{ 'home.buttons.accept' | translate | uppercase }}
      </slotcom-button>
      <slotcom-button
        class="c-button--pink right-btn"
        (safeClick)="acceptDeletion()"
        audioType="functionality">
        {{ 'home.buttons.exit' | translate | uppercase }}
      </slotcom-button>
    </div>
  </div>
</div>
